<template>
  <transition-group>
    <slot></slot>
  </transition-group>
</template>

<script>
export default {
  name: "AppTransitionGroup",
};
</script>

<style scoped></style>
